export default __webpack_public_path__ + "static/media/pixellab--web-design--02a--600x450.f7cdcd57.jpg";